<script setup>
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

onMounted(async () => {
  const urlParams = new URLSearchParams(window.location.hash.replace('#', '?'));
  const idToken = urlParams.get('id_token');
  const refreshToken = urlParams.get('refresh_token');
  const accessToken = urlParams.get('access_token');
  await store.dispatch('users/login', {
    idToken,
    refreshToken,
    accessToken,
  });
  router.replace({ path: '/' });
});
</script>

<template>
  <div></div>
</template>
